import { TableColumnMeta } from "ds/components/Table/types";

export enum SPACELIFT_VCS_REPOS_COLUMN_ID {
  NAME = "NAME",
  DESCRIPTION = "DESCRIPTION",
  LABELS = "LABELS",
  SPACE = "SPACE",
  CREATED_AT = "CREATED_AT",
  DROPDOWN = "DROPDOWN",
}

const MAX_CELL_WIDTH = 2000;

export const SPACELIFT_VCS_REPOS_COLUMNS_STORAGE_KEY = "spaceliftVcsReposColumnsConfig";
export const SPACELIFT_VCS_REPOS_SORT_STORAGE_KEY = "spaceliftVcsReposSortConfig";
export const SPACELIFT_VCS_REPOS_LIMIT_STORAGE_KEY = "spaceliftVcsReposLimit";
export const SPACELIFT_VCS_REPOS_LIMIT = 50;
export const SPACELIFT_VCS_REPOS_PAGINATION_OPTIONS = [10, 25, 50];

export const SPACELIFT_VCS_REPOS_COLUMN_CONFIG: Record<
  SPACELIFT_VCS_REPOS_COLUMN_ID,
  TableColumnMeta
> = {
  [SPACELIFT_VCS_REPOS_COLUMN_ID.NAME]: {
    id: SPACELIFT_VCS_REPOS_COLUMN_ID.NAME,
    title: "Name",
    minWidth: 150,
    defaultWidth: 300,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPOS_COLUMN_ID.DESCRIPTION]: {
    id: SPACELIFT_VCS_REPOS_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 130,
    defaultWidth: 280,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: false,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPOS_COLUMN_ID.LABELS]: {
    id: SPACELIFT_VCS_REPOS_COLUMN_ID.LABELS,
    title: "Labels",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPOS_COLUMN_ID.SPACE]: {
    id: SPACELIFT_VCS_REPOS_COLUMN_ID.SPACE,
    title: "Space",
    minWidth: 140,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    allowsSorting: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPOS_COLUMN_ID.CREATED_AT]: {
    id: SPACELIFT_VCS_REPOS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 170,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: true,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
  },
  [SPACELIFT_VCS_REPOS_COLUMN_ID.DROPDOWN]: {
    id: SPACELIFT_VCS_REPOS_COLUMN_ID.DROPDOWN,
    title: "Repo actions",
    noHeader: true,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    allowsSorting: false,
    resizable: false,
    canHide: false,
    configurable: false,
    canPin: false,
    canMove: false,
  },
};

export const SPACELIFT_VCS_REPOS_SORT_CONFIG: Record<string, string> = {
  [SPACELIFT_VCS_REPOS_COLUMN_ID.NAME]: "name",
  [SPACELIFT_VCS_REPOS_COLUMN_ID.SPACE]: "space",
  [SPACELIFT_VCS_REPOS_COLUMN_ID.CREATED_AT]: "createdAt",
};
